export default "__VITE_ASSET__Bquj8rTR__"